/* eslint-disable jsx-quotes */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

export default class PaginatorPresentation extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            currentPage,
            totalPages,
            previousPage,
            nextPage,
            rowsPerPage,
            itemsRowsPerPage,
            handleRowsPerPage,
        } = this.props;
        return (
            <div className="container-paginator">
                <button type="button" onClick={previousPage}>
                    Anterior
                </button>
                <span>
                    Página {currentPage} de {totalPages === 0 ? 1 : totalPages}
                </span>
                <div className="results-per-page">
                    <label>Resultados por página: </label>
                    <select
                        value={rowsPerPage}
                        onChange={({ target }) =>
                            handleRowsPerPage(target.value)
                        }
                    >
                        {itemsRowsPerPage.map((itemRowsPerPage, index) => (
                            <option key={index} value={itemRowsPerPage}>
                                {itemRowsPerPage}
                            </option>
                        ))}
                    </select>
                </div>
                <button type="button" onClick={nextPage}>
                    Próximo
                </button>
            </div>
        );
    }
}

PaginatorPresentation.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.string.isRequired,
    nextPage: PropTypes.func.isRequired,
    itemsRowsPerPage: PropTypes.array.isRequired,
    previousPage: PropTypes.func.isRequired,
    handleRowsPerPage: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Paginator/PaginatorPresentation.js